import {
  getHeaders,
  handleResponse,
} from './apiService';

// const API_BASE_URL = 'http://127.0.0.1:3000/api/v1';
const API_BASE_URL = 'https://medic-bd-api.onrender.com/api/v1';

const loginUser = async (credentials) => {
  try {
    // Format credentials to match the expected structure from the api
    const formattedCredentials = {
      medic_user: {
        email: credentials.email,
        password: credentials.password,
      },
    };

    const response = await fetch(`${API_BASE_URL}/auth/login`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(formattedCredentials),
      cache: 'no-store',
    });
    const result = await handleResponse(response);

    // Store token and user data in localStorage if login is successful
    if (result && result.token) {
      localStorage.setItem('token', result.token);
      localStorage.setItem('user', JSON.stringify(result.user));
      return {
        success: true,
        user: result.user,
        token: result.token,
      };
    }
    return {
      success: false,
      message: result?.error || 'Login failed',
    };
  } catch (error) {
    console.error('Login error:', error);
    return {
      success: false,
      message: error.message || 'An error occurred during login',
    };
  }
};

const logoutUser = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/logout`, {
      method: 'POST',
      headers: getHeaders(),
    });
    return await handleResponse(response);
  } catch (error) {
    console.error('Logout error:', error);
    return {
      success: false,
      message: error.message || 'An error occurred during logout',
    };
  } finally {
  // Clear localStorage on logout
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
};

const getCurrentUser = async () => {
  const token = localStorage.getItem('token');
  if (!token) {
    return null; // No user is logged in
  }

  try {
    const response = await fetch(`${API_BASE_URL}/auth/me`, {
      method: 'GET',
      headers: getHeaders(),
    });
    return handleResponse(response);
  } catch (error) {
    console.error('Error fetching current user:', error);
    return null;
  }
};

export { loginUser, logoutUser, getCurrentUser };
